import * as assetConstants from '../constants/assets';

const INITIAL_STATE = {
    loading: false,
    actionType: null,
    error: null,
};

export default function batchActionsReducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        // Requests - show loading
        case assetConstants.DUPLICATE_ASSETS_REQUEST:
        case assetConstants.MOVE_ASSETS_REQUEST:
        case assetConstants.COPY_ASSETS_REQUEST:
        case assetConstants.DELETE_ASSETS_REQUEST:
        case assetConstants.TAG_ASSETS_REQUEST:
        case assetConstants.PUBLISH_ASSETS_REQUEST:
            return {
                ...state,
                loading: true,
                actionType: action.type,
                error: null,
            };
        
        // Success - hide loading
        case assetConstants.DUPLICATE_ASSETS_SUCCESS:
        case assetConstants.MOVE_ASSETS_SUCCESS:
        case assetConstants.COPY_ASSETS_SUCCESS:
        case assetConstants.DELETE_ASSETS_SUCCESS:
        case assetConstants.TAG_ASSETS_SUCCESS:
        case assetConstants.PUBLISH_ASSETS_SUCCESS:
            return {
                ...state,
                loading: false,
                actionType: null,
                error: null,
            };
        
        // Failure - hide loading, show error
        case assetConstants.DUPLICATE_ASSETS_FAILURE:
        case assetConstants.MOVE_ASSETS_FAILURE:
        case assetConstants.COPY_ASSETS_FAILURE:
        case assetConstants.DELETE_ASSETS_FAILURE:
        case assetConstants.TAG_ASSETS_FAILURE:
        case assetConstants.PUBLISH_ASSETS_FAILURE:
            return {
                ...state,
                loading: false,
                actionType: null,
                error: action.payload.error,
            };
        
        default:
            return state;
    }
} 


// WEBPACK FOOTER //
// ./src/reducers/batchActionsReducer.js